export const PAGE_NAME = 'HomePage'
export const PAGE_STAGE = 'Discover'
export const REQUESTOR = 'homepage'
